export default {
  apiUrl: "https://omdbapi.com",
  apiKey: "1c357168",
};
